import React from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import MONTHS from '../../shared/months.js';

function MonthlyCommissionsHeader() {
  return (
    <TableRow>
      <TableCell variant="head">Category</TableCell>
      <TableCell variant="head">Tier1</TableCell>
      <TableCell variant="head">Tier2</TableCell>
      <TableCell variant="head">Tier3</TableCell>
      {MONTHS.map((month) => (
        <TableCell key={month} variant="head">
          {month}
        </TableCell>
      ))}
      <TableCell variant="head">Total</TableCell>
    </TableRow>
  );
}

export default React.memo(MonthlyCommissionsHeader);
